import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/pro-regular-svg-icons";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { getAgreementByPublicId } from "../api/Agreement";
import { getUser } from "../api/Users";
import { getTenant } from "../api/Tenants";
import { getLicense } from "../api/Licenses";
import { getAddOnService } from "../api/AddOnServices";
import { getManagedDeviceByPublicId } from "../api/ManagedDevices";
import { useAuth } from "../providers/AuthContext";
import { useSidebar } from "../providers/SidebarContext";



const Breadcrumbs = () => {
  const location = useLocation();
  const { agreementPublicId, tenantPublicId, userPublicId, licensePublicId, addOnServicePublicId, managedDevicePublicId } = useParams();
  const { tenants } = useSidebar();

  const { getAccessToken } = useAuth();

  const [agreementName, setAgreementName] = useState("");
  const [tenantName, setTenantName] = useState("");
  const [userName, setUserName] = useState("");
  const [licenseName, setLicenseName] = useState("");
  const [addOnServiceName, setAddOnServiceName] = useState("");
  const [managedDeviceName, setManagedDeviceName] = useState("");

  useEffect(() => {
    const fetchNames = async () => {
      const accessToken = await getAccessToken();
      
      try {
        if (agreementPublicId) {
          const agreement = await getAgreementByPublicId(agreementPublicId, accessToken);
          setAgreementName(agreement.name || agreement.agreementName || "Agreement"); 
        }
        if (tenantPublicId) {
          const tenant = tenants.find(t => t.tenantPublicId === tenantPublicId);
          if (tenant) {
            setTenantName(tenant.displayName || tenant.name || "Tenant");
          }
        }
        if (userPublicId) {
          const user = await getUser(userPublicId, accessToken);
          setUserName(user.displayName || user.userPrincipalName || "User"); 
        }
        if (licensePublicId) {
          const license = await getLicense(licensePublicId, accessToken);
          setLicenseName(license.name || "License");
        }
        if (addOnServicePublicId) {
          const addOnService = await getAddOnService(addOnServicePublicId, accessToken);
          setAddOnServiceName(addOnService.name || "Add-on service");
        }
        if (managedDevicePublicId) {
          const device = await getManagedDeviceByPublicId(managedDevicePublicId, accessToken);
          setManagedDeviceName(device.deviceName || "Device");
        }
      } catch (error) {
        console.error("Failed to fetch names for breadcrumbs:", error);
      }
    };

    fetchNames();
  }, [agreementPublicId, tenantPublicId, userPublicId, licensePublicId, addOnServicePublicId, managedDevicePublicId, getAccessToken]);
    
  

  let pathnames = location.pathname.split("/").filter((x) => x);

  // Remove the last segment if it is "Edit"
  if (pathnames[pathnames.length - 1] === "edit") {
    pathnames = pathnames.slice(0, -1);
  }

  const getBreadCrumbName = (segment) => {
    if (segment === agreementPublicId) return agreementName || segment;
    if (segment === tenantPublicId) return tenantName || segment;
    if (segment === userPublicId) return userName || segment;
    if (segment === licensePublicId) return licenseName || segment;
    if (segment === addOnServicePublicId) return addOnServiceName || segment;
    if (segment === managedDevicePublicId) return managedDeviceName || segment;
    if (segment === "hardware-order") return "Order hardware";
    return capitalize(segment);
  };

  const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);

  return (
    <nav className="breadcrumb">
      <ul className="flex items-center">
        <li className="text-primary-600 text-xs">
          <Link to="/">
          <FontAwesomeIcon icon={faHome} className="mr-1" />
          Home
          </Link>
        </li>
        {pathnames.length > 0 && <li className="mx-1">/</li>}

        {pathnames.map((value, index) => {
          const to = `/${pathnames.slice(0, index + 1).join("/")}`;
          const isLast = index === pathnames.length - 1;
          return (
            <React.Fragment key={to}>
              <li className="text-xs">
                {isLast ? (
                  <span>{getBreadCrumbName(value)}</span>
                ) : (
                  <Link to={to} className="text-xs">{getBreadCrumbName(value)}</Link>
                )}
              </li>
              {!isLast && <li className="mx-1">/</li>}
            </React.Fragment>
          );
        })}
      </ul>
    </nav>
  );
};

export default Breadcrumbs;
